import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Button,
} from '@mui/material';

const styles = {
  yearControl: {
    // margin: 10,
    margin: 1,
    minWidth: 100,
  },
  monthControl: {
    // margin: 10,
    margin: 1,
    minWidth: 150,
  },
  buttonControl: {
    height: '100%',
  },
};
const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function getYears() {
  const years = [];
  let yearCount = 2011;
  const thisYear = new Date().getFullYear();
  while (yearCount <= thisYear + 2) {
    years.push(yearCount);
    yearCount++;
  }
  years.sort((a, b) => b - a);
  return years;
}

export default function DatePicker(props) {
  const [year, setYear] = useState(props.defaultYear);
  const [month, setMonth] = useState(props.defaultMonth);

  useEffect(() => {
    setYear(props.defaultYear);
    setMonth(props.defaultMonth);
  }, [props.defaultYear, props.defaultMonth]);

  return (
    <Grid container justify='center' alignItems='center'>
      <Grid item>
        <FormControl variant='standard' sx={styles.yearControl}>
          <InputLabel>Year</InputLabel>
          <Select
            value={year || new Date().getFullYear()}
            onChange={(event) => setYear(event.target.value)}
          >
            {getYears().map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item>
        <FormControl variant='standard' sx={styles.monthControl}>
          <InputLabel>Month</InputLabel>
          <Select
            value={month}
            onChange={(event) => setMonth(event.target.value)}
          >
            {MONTH_NAMES.map((m) => (
              <MenuItem key={m} value={MONTH_NAMES.indexOf(m) + 1}>
                {m}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item>
        <FormControl sx={styles.buttonControl}>
          <Button
            component={Link}
            to={`/${year}-${month}`}
            replace={true}
            variant='contained'
            color='primary'
          >
            Submit
          </Button>
        </FormControl>
      </Grid>
    </Grid>
  );
}
